<template>
  <v-list-tile @click="open">
    <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'plus']"></font-awesome-icon></v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-title>住所を追加する</v-list-tile-title>
    </v-list-tile-content>
    <v-list-tile-action class="text-xs-right">
      <v-btn flat :disabled="true"></v-btn>
    </v-list-tile-action>
    <v-dialog scrollable v-model="config.status.active" max-width="600">
      <v-card>
        <v-card-title class="grey lighten-3 blue-grey--text text--darken-4">
          <span class="headline">住所の追加</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md class="pa-0">
            <v-form ref="form" v-model="form.valid" lazy-validation>
              <v-layout wrap>
                <v-flex xs10>
                  <v-text-field required
                    v-model="form.zip"
                    label="郵便番号"
                    mask="###-####"
                    :rules="rules.zip"
                    @keypress.enter="search"></v-text-field>
                </v-flex>
                <v-flex xs2>
                  <v-btn icon flat
                    color="blue darken-2"
                    :loading="isSearching"
                    @click.stop="search"
                  ><font-awesome-icon :icon="['fas', 'search']" /></v-btn>
                </v-flex>
                <v-flex xs12 class="">
                  <v-select required
                    v-model="form.pref"
                    label="都道府県"
                    :items="getPrefItems"
                    :rules="rules.pref"></v-select>
                </v-flex>
                <v-flex xs12 class="">
                  <v-text-field required
                    v-model="form.city"
                    label="市町村区"
                    :rules="rules.city"></v-text-field>
                </v-flex>
                <v-flex xs12 class="">
                  <v-text-field ref="number" required
                    v-model="form.number"
                    label="番地・建物"
                    :rules="rules.number"></v-text-field>
                </v-flex>
                <v-flex xs12 class="">
                  <v-text-field required
                    v-model="form.kana"
                    label="ふりがな"
                    :rules="rules.kana"></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="grey lighten-3">
          <v-btn flat
            color="blue darken-2"
            @click="close">閉じる</v-btn>
          <v-spacer></v-spacer>
          <v-btn depressed color="blue darken-2" class="white--text"
            :disabled="!isValid"
            :loading="isLoading"
            @click="submit">追加する</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-list-tile>
</template>

<script>
export default {
  name: 'insert-modal',
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false,
          searching: false
        }
      },
      rules: {
        zip: [
          v => !!v || '必須項目です'
        ],
        pref: [
          v => !!v || '必須項目です'
        ],
        city: [
          v => !!v || '必須項目です'
        ],
        number: [
          v => !!v || '必須項目です'
        ],
        kana: [
          v => !!v || '必須項目です',
          v => !/[^ぁ-ん]/.test(v) || '平仮名のみ入力有効です'
        ]
      },
      form: {
        valid: true,
        zip: '',
        pref: '',
        city: '',
        number: '',
        kana: ''
      }
    }
  },
  methods: {
    init: function () {
      this.$set(this, 'form', {
        valid: true,
        zip: '',
        pref: '',
        city: '',
        number: '',
        kana: ''
      })
    },
    open: function () {
      this.init()
      this.$set(this.config.status, 'active', true)
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$set(this.config.status, 'loading', true)
        this.axios.post(this.$url.api + 'user/about/insert/address', {
          zip: this.form.zip,
          pref: this.form.pref,
          city: this.form.city,
          number: this.form.number,
          kana: this.form.kana
        }, {
          headers: {
            'user-token': this.$localStorage.get('jwt')
          }
        }).then(res => {
          console.log(res)
          if (res.data && res.data.success) {
            this.$emit('emit', {
              action: 'insert',
              data: res.data.data
            })
          }
          this.$set(this.config.status, 'loading', false)
          this.$set(this.config.status, 'active', false)
        })
      }
    },
    search: function () {
      if (this.form.zip.length === 7 && !this.config.status.searching) {
        this.$set(this.config.status, 'searching', true)
        this.axios.get(this.$url.zip + this.form.zip).then(res => {
          console.log(res)
          if (res.data.code === 200) {
            let data = res.data.data
            this.$set(this.form, 'pref', data.pref)
            this.$set(this.form, 'city', data.city)
            this.$set(this.form, 'number', data.town)
            this.$set(this.config.status, 'searching', false)
            this.$refs.number.focus()
            this.$store.dispatch('notifier/addSMessage', {
              title: '住所が見つかりました',
              message: data.pref + data.city + data.town
            })
          } else {
            this.$store.dispatch('notifier/addAlert', {
              title: '住所検索失敗',
              message: this.$error.zip.search.unmatch
            })
          }
        }).catch(error => {
          console.log(error)
        })
      }
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    isLoading () {
      return this.config.status.loading
    },
    isSearching () {
      return this.config.status.searching
    },
    getPrefItems () {
      return Object.keys(this.$meta.prefs)
    }
  }
}
</script>
